import { useQueryClient } from '@tanstack/react-query';
import queryString from 'query-string';

import type { PreviewResult } from 'app/redux/models/PreviewResult/PreviewResult';
import { apiRequest } from 'app/utils/request/api';

const path = 'admin/quick-filters/preview' as const;

export const usePreviewResults = () => {
  const queryClient = useQueryClient();

  const getPreviewResults = (tagIds: number[], dayPackage: boolean) => {
    return queryClient.fetchQuery<
      PreviewResult[],
      unknown,
      PreviewResult[],
      (
        | typeof path
        | {
            tagIds: number[];
            dayPackage: boolean;
          }
      )[]
    >({
      queryKey: [path, { dayPackage, tagIds }],
      queryFn: () =>
        apiRequest({
          path: `${path}?${queryString.stringify({ dayPackage, tagIds })}`,
        }),
    });
  };

  return {
    getPreviewResults,
  };
};
